import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'wallShade',
      d: 'M-0.5,-10h0.5v0.5h-0.5zM0.5,-10h1v1h-1zM1,-9h0.5v0.5h-0.5zM-0.5,-6.5h0.5v0.5h-0.5zM0.5,-6.5h1.5v1h-1.5zM1.5,-5.5h0.5v0.5h-0.5zM-2.5,-3h1v0.5h-1zM2,-3h1v0.5h-1zM0,-2.5h3v2h-3zM-4,-0.5h1.5v0.5h-1.5zM0,-0.5h4v1h-4zM-4,0h2.5v0.5h-2.5zM-4,0.5h8v0.5h-8zM-2,1h4v0.5h-4z',
    },
    {
      paint: 'epicMarble',
      d: 'M-1.5,-10h1v1h-1zM-2,-6.5h1.5v0.5h-1.5zM-2,-6h1v0.5h-1zM-3,-3h0.5v0.5h-0.5zM-3,-2.5h3v0.5h-3zM-3,-2h1.5v1.5h-1.5zM-0.5,-2h0.5v2h-0.5zM-2.5,-0.5h1v0.5h-1zM-1.5,0h1.5v0.5h-1.5z',
    },
    {
      paint: 'trunk',
      d: 'M-3,-11h1v0.5h-1zM2,-11h1v0.5h-1zM-2.5,-10.5h5v0.5h-5zM0,-10h0.5v0.5h-0.5zM-0.5,-8.5h0.5v1h-0.5zM3.5,-8h0.5v0.5h-0.5zM-4,-7.5h2v0.5h-2zM2,-7.5h2v0.5h-2zM-3.5,-7h7v0.5h-7zM0,-6.5h0.5v0.5h-0.5zM-1,-5.5h1v1.5h-1zM4.5,-4.5h0.5v0.5h-0.5zM-5,-4h1.5v0.5h-1.5zM3.5,-4h1.5v0.5h-1.5zM-4.5,-3.5h3.5v0.5h-3.5zM1,-3.5h3.5v0.5h-3.5zM-1.5,-3h3.5v0.5h-3.5zM-1.5,-2h1v2h-1z',
    },
    {
      paint: 'roofA',
      d: 'M0,-12.5h0.5v0.5h-0.5zM0,-12h1.5v0.5h-1.5zM0,-11.5h2.5v0.5h-2.5zM0,-11h2v0.5h-2zM0,-9.5h0.5v0.5h-0.5zM0,-9h1v0.5h-1zM0,-8.5h2.5v0.5h-2.5zM0,-8h3.5v0.5h-3.5zM0,-7.5h2v0.5h-2zM0,-6h0.5v0.5h-0.5zM0,-5.5h1.5v0.5h-1.5zM0,-5h3v0.5h-3zM0,-4.5h4.5v0.5h-4.5zM0,-4h3.5v0.5h-3.5zM0,-3.5h1v0.5h-1z',
    },
    {
      paint: 'roofB',
      d: 'M-1,-12.5h1v0.5h-1zM-2,-12h2v0.5h-2zM-3,-11.5h3v0.5h-3zM-2,-11h2v0.5h-2zM-0.5,-9.5h0.5v0.5h-0.5zM-2,-9h2v0.5h-2zM-3.5,-8.5h3v0.5h-3zM-4,-8h3.5v0.5h-3.5zM-2,-7.5h2v0.5h-2zM-1,-6h1v0.5h-1zM-2.5,-5.5h1.5v0.5h-1.5zM-4,-5h3v0.5h-3zM-5,-4.5h4v0.5h-4zM-3.5,-4h3.5v0.5h-3.5zM-1,-3.5h1v0.5h-1z',
    },
    { paint: 'epicGold', d: 'M-0.5,-14h1v1.5h-1z' },
  ],
  pixels: 339,
};
export const sprites: readonly PixelSprite[] = [variant0];
